import { FormEvent, useState } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet-async';
import { MessageCircle, Send } from 'react-feather';
import { PACOCA_API_URL } from '../../global-components/src/utils/vars';
import './style.css';

const PacocaPapo = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (isSubmitting) return;

    setIsSubmitting(true);
    setStatus('idle');
    setMessage('');

    try {
      const { data } = await axios.post(`${PACOCA_API_URL}/pacoca-papo/testers`, {
        email: email.trim(),
      });

      setStatus('success');
      setMessage(
        data?.already_registered
          ? 'Seu e-mail já foi enviado para @joao. Ele avisará quando houver uma vaga no teste.'
          : 'Pronto! Seu e-mail foi enviado para @joao.',
      );
    } catch (error) {
      const apiMessage = axios.isAxiosError(error)
        ? error.response?.data?.message
        : null;

      setStatus('error');
      setMessage(
        typeof apiMessage === 'string'
          ? apiMessage
          : 'Não foi possível enviar seu e-mail agora. Tente novamente em instantes.',
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="pacoca-papo-page">
      <Helmet>
        <title>Paçoca Papo — WhatsApp Brasileiro</title>
        <meta
          name="description"
          content="Entre na fase de testes do Paçoca Papo, o WhatsApp brasileiro do Paçoca."
        />
      </Helmet>

      <section className="pacoca-papo-card" aria-labelledby="pacoca-papo-title">
        <div className="pacoca-papo-icon" aria-hidden="true">
          <MessageCircle size={34} />
        </div>
        <p className="pacoca-papo-eyebrow">APP EM TESTE</p>
        <h1 id="pacoca-papo-title">Paçoca Papo</h1>
        <p className="pacoca-papo-subtitle">WhatsApp Brasileiro</p>
        <p className="pacoca-papo-description">
          O Paçoca Papo ainda está em fase de testes. Deixe seu e-mail para que
          <strong> @joao</strong> possa liberar seu acesso quando houver uma vaga. O email Google que usa no seu celular, para a Play Store aprovar.
        </p>

        <form className="pacoca-papo-form" onSubmit={submit}>
          <label htmlFor="pacoca-papo-email">Seu e-mail</label>
          <div className="pacoca-papo-form-row">
            <input
              id="pacoca-papo-email"
              name="email"
              type="email"
              autoComplete="email"
              placeholder="voce@exemplo.com"
              value={email}
              onChange={event => setEmail(event.target.value)}
              disabled={isSubmitting}
              required
            />
            <button type="submit" disabled={isSubmitting}>
              <Send size={17} aria-hidden="true" />
              {isSubmitting ? 'Enviando...' : 'Enviar para @joao'}
            </button>
          </div>
        </form>

        {status !== 'idle' && (
          <p
            className={`pacoca-papo-feedback pacoca-papo-feedback--${status}`}
            role={status === 'error' ? 'alert' : 'status'}
          >
            {message}
          </p>
        )}
      </section>
    </main>
  );
};

export default PacocaPapo;
